import React, { Component } from 'react';
import AccountService from '../services/AccountService';
import ChatTopBar from './Chat/ChatTopBar';
import ChatViewCentral from './Chat/ChatViewCentral';


export default class TestPage extends Component {

    constructor(props) {
        super(props);
        this.defaultProps = {}
        this.state = {

        }

        this.accountService = new AccountService();

        let self = this;
        self.props.superInit(self.props.loadingOff, undefined, undefined, undefined);

        // if (window.localStorage["isAuthed"] != 'true') {
        //     this.props.logout();
        // } else {
        //     this.accountService.ping(() => {
        //         self.props.loadingOff();
        //     }, () => {
        //         self.props.logout();
        //     });
        // }
    }



    componentDidMount() { }

    componentWillReceiveProps() {

    }

    render() {
        return (
            <div id="page-outer" className="chat-page-outer">
                <ChatTopBar
                    toggleNav={this.props.toggleNav}
                />
                <ChatViewCentral

                />
            </div>

        );
    }
}
